import { render, staticRenderFns } from "./previewImgAndPdf.vue?vue&type=template&id=866a1792"
import script from "./previewImgAndPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./previewImgAndPdf.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports